export const SYSTEM_LOGO = "https://www.codefather.cn/_next/image?url=%2Fimages%2Flogo.png&w=256&q=75";

export const PLANT_DOC = "https://www.codefather.cn/post/1808579070099849217"
